import React from 'react'
import './loader.scss';
const Loader = (props) => {
    return (
        <div className={props.active ? "loader-container active" : "loader-container"}>
            <div className="loader"></div>
        </div>
    );
}

export default Loader;


// WEBPACK FOOTER //
// ./src/Components/Loader/Loader.js